const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/users/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import type { UserListItem } from "@/types/api/user";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/client/users/")({
  beforeLoad: args => requirePermission(Permissions.ClientUsers.ViewAll, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/**
 * Client users (founder, 2026-09-14): invitation status (same badges as
 * onboarding step 5), groups, roles (direct or via a group), notification
 * roles, last sign-in, user type and owner — filterable by status,
 * invitation, group and type, with Send / Resend invitation per row.
 * Data: Client `Users/GetAll` through the admin `GET /users` proxy.
 */

/** One chip per role name; the tooltip lists where it comes from. */